/**
 * Sub-flow markers carried in the `flow` query param alongside `source` (REDIRECT_SOURCE).
 *
 * `source` identifies the referring entity (an EntityResourceIds, e.g. BUSINESS_CASE); `flow`
 * disambiguates which sub-flow within that entity opened the target form. They are kept as
 * separate params so `source` always holds a real EntityResourceIds value.
 */
export const redirectFlow = {
  tradeIn: 'trade-in',
} as const;
